import { Typography } from "@material-ui/core";
import { FC } from "react";

import { qar } from "../../../../utils/generic";

const ServicePrice: FC<any> = ({ record }) => {
  return (
    <>
      <Typography data-testid="ServicePrice" variant="body2">
        {qar(record.price)}
      </Typography>
    </>
  );
};

export default ServicePrice;
